import { Box, IconButton, Tooltip } from '@mui/material';
import { Check } from '@mui/icons-material';

// 16 standard colors for consistent design
const PALETTE_COLORS = [
  // Row 1: Grayscale
  { name: 'Black', value: '#151414' },
  { name: 'Dark Gray', value: '#4a4a4a' },
  { name: 'Gray', value: '#808080' },
  { name: 'Light Gray', value: '#c0c0c0' },
  // Row 2: Warm colors
  { name: 'Red', value: '#e53935' },
  { name: 'Orange', value: '#fb8c00' },
  { name: 'Yellow', value: '#fdd835' },
  { name: 'Pink', value: '#ec407a' },
  // Row 3: Cool colors
  { name: 'Purple', value: '#8e24aa' },
  { name: 'Blue', value: '#1e88e5' },
  { name: 'Light Blue', value: '#29b6f6' },
  { name: 'Cyan', value: '#00acc1' },
  // Row 4: Nature colors
  { name: 'Teal', value: '#26a69a' },
  { name: 'Green', value: '#43a047' },
  { name: 'Lime', value: '#7cb342' },
  { name: 'Brown', value: '#6d4c41' },
];

type ColorPaletteProps = {
  value: string;
  onChange: (color: string) => void;
  includeWhite?: boolean;
};

export const ColorPalette = ({ value, onChange, includeWhite = false }: ColorPaletteProps) => {
  const colors = includeWhite
    ? [{ name: 'White', value: '#ffffff' }, ...PALETTE_COLORS]
    : PALETTE_COLORS;

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gap: 0.5,
        p: 1,
        bgcolor: 'grey.100',
        borderRadius: 1,
      }}
    >
      {colors.map((color) => (
        <Tooltip key={color.value} title={color.name} placement="top">
          <IconButton
            onClick={() => onChange(color.value)}
            sx={{
              width: 32,
              height: 32,
              bgcolor: color.value,
              border: color.value === '#ffffff' ? '1px solid #ccc' : 'none',
              borderRadius: 1,
              '&:hover': {
                bgcolor: color.value,
                opacity: 0.8,
              },
            }}
          >
            {value.toLowerCase() === color.value.toLowerCase() && (
              <Check
                sx={{
                  fontSize: 18,
                  color: ['#ffffff', '#fdd835', '#c0c0c0', '#29b6f6'].includes(color.value)
                    ? '#333'
                    : '#fff',
                }}
              />
            )}
          </IconButton>
        </Tooltip>
      ))}
    </Box>
  );
};

export { PALETTE_COLORS };
